import * as React from 'react';
import NavigationPanel from '@/pages/eventEditing/components/navigationComponent/navigationComponent'
import GeneralTabPanel from '@pages/eventEditing/components/tabPanels/generalTabPanel.tsx'
import DateAndLocationTabPanel from '@pages/eventEditing/components/tabPanels/dateAndLocationTabPanel.tsx'
import PhotoAndDescriptionTabPanel from  '@pages/eventEditing/components/tabPanels/photoAndDesriptionTabPanel.tsx'
import ConditionsTabPanel from '@pages/eventEditing/components/tabPanels/conditionsTabPanel.tsx'
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import CogwheelIcon from '@assets/svg/button-icons/cogwheel.svg?react';
import LocationIconCard from '@assets/svg/location_icon_for_editingPage.svg?react'
import BurgerMenuIcon from '@assets/svg/burger_menu_icon.svg?react'
import BellIcon from '@assets/svg/bell_icon.svg?react'
import styledLabel from '@/pages/eventEditing/components/styledLabel/styledLabel'
import { TabsMobileViewProps } from '@pages/eventEditing/components/types.ts'
import EventDeletionComplex from '@pages/eventEditing/components/eventDeletionComplex/eventDeletionComplex.tsx'
import useUpdateEventRequest from '@pages/eventEditing/hooks/useUpdateEventRequest.ts'


export default function TabsComponentMobileView({ handleClickBack, formik, photo, orgId, eventId }: TabsMobileViewProps) {
	const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [showPanels, setShowPanels] = React.useState(false)
  const { editHandler, isLoading } = useUpdateEventRequest()

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
  };

  const itemsStructuredData = React.useMemo(() => ({
    1: {label: {text: 'Основные', icon: <CogwheelIcon />}, panel: <GeneralTabPanel formik={formik}/>},
    2: {label: {text: 'Время и место', icon: <LocationIconCard />}, panel: <DateAndLocationTabPanel formik={formik}/>},
    3: {label: {text: 'Описание и фото', icon: <BurgerMenuIcon />}, panel: <PhotoAndDescriptionTabPanel formik={formik} initialPhoto={photo}/>},
    4: {label: {text: 'Разрешения', icon: <BellIcon />}, panel: <ConditionsTabPanel formik={formik}/>},
  }), [formik.values])
  const itemsIndexes = Object.keys(itemsStructuredData).map((index) => Number(index))

  return (
    <>
    <Box sx={{ display: showPanels ? 'none' : 'block', width: '100%', bgcolor: 'transperent' }}>
      <NavigationPanel text={'Редактирование события'} handleClick={handleClickBack} />
      <List sx={{marginTop: '32px'}} component="nav" aria-label="main mailbox folders">
        {itemsIndexes.map((index) => {
          return (
            <ListItemButton
            sx={{color: 'var(--Schemes-On-Surface)'}}
            selected={selectedIndex === index}
            onClick={(event) => {
              handleListItemClick(event, index)
              setShowPanels(true)
            }}
          >
            <ListItemText primary={styledLabel(itemsStructuredData[index].label.text, itemsStructuredData[index].label.icon)} />
          </ListItemButton>
          )
        })}
      </List>
      <Box sx={{marginTop: '16px', display: 'flex', flexDirection:"column", justifyContent: 'center', alignItems: 'center'}}> 
        <EventDeletionComplex orgId={orgId} eventId={eventId}/>
      </Box>
		</ Box>

    <Box sx={{ display: showPanels ? 'block' : 'none'}}>
      <NavigationPanel text={itemsStructuredData[selectedIndex].label.text} handleClick={() => setShowPanels(false)} />
      <Box sx={{margin: '32px 30px'}}>
        {itemsStructuredData[selectedIndex].panel}
        <Button onClick={() => editHandler(formik.values)} disabled={isLoading} sx={{display: 'block', margin: "18px auto"}} variant="text">Применить</Button>
      </Box>
    </Box>
    </>
	)
}